import { SHOW_TOAST,CLEAR_TOAST } from "./types";

const initialState = {
  message: "",
  type: "",
};

const toastReducer = (state = initialState, action :any) => {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        message: action.payload.message,
        type: action.payload.type,
      };
      case CLEAR_TOAST:
        return {
          ...state,
          message: null,
          type: null,
        };
    default:
      return state;
  }
};

export default toastReducer;
